import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WINDOW } from '@frontend/vanilla/core';

import { MyBetsListContext, MyBetsSlipEditBetHistoryViewModel } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsEditBetHistoryService } from '../../services/my-bets-edit-bet-history.service';
import { MyBetsPrintService } from '../../services/my-bets-print.service';

@Component({
    selector: 'ms-my-bets-edit-bet-history-list',
    templateUrl: './my-bets-edit-bet-history-list.html',
})
export class MyBetsEditBetHistoryListComponent implements OnInit, OnDestroy {
    @Input() myBetsListContext: MyBetsListContext;
    betslips: MyBetsSlipEditBetHistoryViewModel[];

    constructor(
        public sitecore: Sitecore,
        private editBetHistoryService: MyBetsEditBetHistoryService,
        private printService: MyBetsPrintService,
    ) {
        this.betslips = this.editBetHistoryService.editBetHistoryBetslips;
    }

    ngOnInit(): void {
        this.#window.scrollTo(0, 0);
    }

    ngOnDestroy(): void {
        this.editBetHistoryService.resetEditBetHistory();
    }

    get showPrintButton(): boolean {
        return !!this.myBetsListContext.showPrintButton;
    }

    get printButtonTitle(): string {
        return this.sitecore.myBets_Print?.PrintButtonTitle;
    }

    onPrintBtnClicked(event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        this.printService.printEditMyBetsHistory(this.betslips[0].betslipId, this.myBetsListContext.associatedAccount);
    }

    readonly #window = inject(WINDOW);
}
